import * as React from 'react';
import * as style from './BackgroundImage.css';

export const BackgroundImage: React.FC = () => {
  return <div className={style['image']} />;
};
